import { useTranslation } from 'react-i18next'

import { useDateLocale } from '../../../../hooks'
import Text from '../../../Text'
import { formatCalendarDate } from '../../Calendar.utils'

import {
  CALENDAR_FOLLOW_UP_CAP_REQUEST_COUNT,
  QA_NAME_CALENDAR_FOLLOW_UP_CAP_COLLEAGUE,
} from './ColleagueLoads.constants'

import * as styles from './ColleagueLoads.module.css'

function ColleagueLoads({ colleagues }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return (
    <div className={styles.ColleagueLoads}>
      {colleagues.map(colleague => (
        <Text
          key={colleague.userId}
          qaName={QA_NAME_CALENDAR_FOLLOW_UP_CAP_COLLEAGUE}
        >
          {t('Calendar.CapWarningMassKey', {
            count: CALENDAR_FOLLOW_UP_CAP_REQUEST_COUNT,
            date: formatCalendarDate({ date: colleague.date, locale }),
            limit: colleague.limit,
            used: colleague.used,
            user: colleague.user,
          })}
        </Text>
      ))}
    </div>
  )
}

export default ColleagueLoads
